import { request } from '@/axios';
import { type ListCommonParams, type ListResponse } from '@/types/list';

// 本地上传
interface ImageItem {
  width: number;
  height: number;
  image: string;
  size: number;
}
interface LocalUpload {
  artworkId?: number;
  image: ImageItem[];
  type: 2 | 3 | 4 | 5; // 2: 本地上传 3: 姿势图 4: 蒙板图 5: 
}
export function localUpload(data: LocalUpload) {
  return request<LocalUploadImageState[]>({
    api: '/api/localUpload/localUpload',
    method: 'post',
    data
  });
}

// 获取当前作品本地上传列表
export interface LocalUploadImageState {
  artworkId?: number;
  collect?: number;
  ctime: string;
  deleteStatus?: number;
  glb?: string;
  height: number;
  id: number;
  image: string;
  pixeloeImg?: string;
  redrawWeight?: number;
  size?: number;
  type: number;
  upload?: number;
  userId?: number;
  utime: string;
  versionId: number;
  width: number;
}
export function queryLocalUpload(data: ListCommonParams) {
  return request<ListResponse<LocalUploadImageState[]>>({
    api: '/api/localUpload/listLocalUpload',
    method: 'post',
    data
  });
}

// V2 接口：使用游标分页的本地上传列表
export interface LocalUploadListReqV2 {
  artworkId?: number;
  lastId?: number;
  pageNo: number;
  pageSize: number;
  type?: number;
}
export function queryLocalUploadV2(data: LocalUploadListReqV2) {
  return request<LocalUploadImageState[]>({
    api: '/api/localUpload/listLocalUploadV2',
    method: 'post',
    data
  });
}


/**
 * 批量删除作品图片
 */
export function batchDelArtworkImg(imgIdList: number[]) {
  return request<{success: boolean;msg: string;}>({
    api: '/api/artwork/batchDelArtworkImg',
    method: 'post',
    data: {
      imgIdList
    }
  });
}

/**
 * 删除本地上传图片 / 自由画布资源
 *
 * 用于参考图库（type=2 本地上传）和上传素材（自由画布资源）的删除，
 * 替代原先复用的 batchDelArtworkImg（作品图片删除接口，契约不匹配）。
 */
export function deleteLocalUpload(imgIdList: number[]) {
  return request<{success: boolean;msg: string;}>({
    api: '/api/localUpload/deleteLocalUpload',
    method: 'post',
    data: {
      imgIdList
    }
  });
}
